/** @returns {import("../reducer/data").ChatDataReducer}  */
export const getState = state => state.chat.data;

/** @returns {import("../reducer/ui").ChatUIReducer}  */
export const getUIState = state => state.chat.ui;
